/**
 * Serviço da Lista de Espera (waitlist).
 *
 * Entradas são criadas APENAS pelo chatbot quando todos os horários de um
 * serviço estão ocupados. Aqui o dono do negócio apenas visualiza e remove.
 *
 * Rotas (escopadas por JWT no backend):
 *  - GET    /api/waitlist/:tenantId  → entradas ACTIVE e NOTIFIED (service incluído)
 *  - DELETE /api/waitlist/:id        → cancela (status → CANCELLED)
 */
import api from "./api";

/**
 * Lista as entradas ACTIVE/NOTIFIED da fila de espera do tenant.
 * @param {string} tenantId - ID do tenant logado (obtido via AuthContext).
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const listWaitlist = (tenantId) => api.get(`/waitlist/${tenantId}`);

/**
 * Cancela (remove) uma entrada da fila de espera.
 * @param {string} id - ID da entrada.
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const cancelWaitlist = (id) => api.delete(`/waitlist/${id}`);
